<template lang="html">
	<main class="register-bg">
		<div class="aligner">

			<div id="register-user-form">
        <h3 class="white-text text-center" id="register-page-headline">Opret profil på Odense Rundt</h3>
				<div v-show="!registerSucces">
					<input type="email" v-model="newUserEmail" placeholder="E-mail" aria-label="Din email" @blur="checkUserEmail();" :class="{'error-outline' : emailNameError || emailInvalidError}">
					<div class="error" v-show="emailNameError">E-mail eksisterer allerede</div>
					<div class="error" v-show="emailInvalidError">Ikke gyldig e-mail</div>

					<input type="password" placeholder="Password" aria-label="Din kodeord" v-model="newUserPassword" @blur="checkUserPassword();" :class="{'error-outline' : passwordRepeatError || passwordLengthError}">
					<input type="password" placeholder="Gentag password" aria-label="Gentag kodeord" v-model="newUserPasswordRepeat" @blur="comparePasswords();">
					<div class="error" v-show="passwordRepeatError">Password er ikke ens</div>
					<div class="error" v-show="passwordLengthError">Password skal være minimum 6 tegn langt</div>

					<button id="submit-user-btn" type="submit" class="btn blue" @click="validateInput();">Opret profil</button>
				</div>

				<div v-show="registerSucces">
					<p class="white-text">Sådan! Du har nu oprettet en profil på Odense Rundt. Du mangler bare lige at aktivere den via det link, der ligger og venter på dig i din indbakke :-)</p>
					<router-link to="/login"><button id="register-user-success-btn" class="btn blue">Gå til login</button></router-link>
				</div>
			</div>

		</div>
	</main>
</template>

<script>
import axios from 'axios'

export default {
  data() {
    return {
			newUserEmail: '',
			newUserPassword: '',
			newUserPasswordRepeat: '',
      emailNameError: false,
      emailInvalidError: false,
      passwordRepeatError: false,
      passwordLengthError: false,
      userEmailValid: false,
      userPasswordValid: false,
      userPasswordRepeatValid: false,
      registerSucces: false,
    }
  },
	created() {
		this.$HelperFunctions.scrollToTop();
		this.$HelperFunctions.setPageTitle('Registrer ny bruger');
	},
  mounted() {
		this.$HelperFunctions.setScreenReaderFocus('register-page-headline');
  },
  methods: {
  	validateInput() {
  		console.log(this.userEmailValid);
  		console.log(this.userPasswordValid);
  		console.log(this.userPasswordRepeatValid);
  		if(this.userEmailValid && this.userPasswordValid && this.userPasswordRepeatValid) {
  			this.submitNewUser();
  		}
  	},

  	checkUserEmail() {
      this.emailInvalidError = false;
      this.emailNameError = false;
  		this.userEmailValid = false;

  		var atpos = this.newUserEmail.indexOf("@");
  		var dotpos = this.newUserEmail.lastIndexOf(".");

  		if (atpos<1 || dotpos<atpos+2 || dotpos+2 >= this.newUserEmail.length) {
  			this.emailInvalidError = true;
  		}
  		else {
        this.userEmailValid = true;
				const params = new URLSearchParams();
		    params.append('action', 'checkMail');
		    params.append('email', this.newUserEmail);

		    axios({
		      method: 'post',
		      url: 'https://apps.odenserundt.dk/apptools/orApi/',
		      data: params
		    }).then((response) => {
					console.log(response);
					if(response.data.type == 'email.found') {
  					this.emailNameError = true;
  				}
  				else if(response.data.type == 'email.notfound') {
  					this.userEmailValid = true;
  				}
		    });
  		}
  	},

  	checkUserPassword() {
      this.passwordLengthError = false;
  		this.userPasswordValid = false;
  		if(this.newUserPassword.length >= 6) {
  			this.userPasswordValid = true;
  		}
  		else {
  			this.passwordLengthError = true;
  		}
  	},

  	comparePasswords() {
      this.passwordRepeatError = false;
  		this.userPasswordRepeatValid = false;

  		if(this.newUserPassword === this.newUserPasswordRepeat) {
  			this.userPasswordRepeatValid = true;
  		}
  		else {
  			this.passwordRepeatError = true;
  		}
  	},

    submitNewUser() {
			const params = new URLSearchParams();
			params.append('action', 'register');
			params.append('email', this.newUserEmail);
			params.append('pass', this.newUserPassword);

			axios({
				method: 'post',
				url: 'https://apps.odenserundt.dk/apptools/orApi/',
				data: params
			}).then((response) => {
				console.log(response);
  			if(response.data.type == 'reg_ok.local') {
					this.registerSucces = true;
  				this.$HelperFunctions.trackSession('user', 'new-user-created');
  			}
			});
    }
  },
}
</script>

<style lang="css" scoped>
.register-bg {
  height: 100%;
  width: 100%;
  background-image: url('https://apps.odenserundt.dk/apptools/img/register-bg.jpg');
  background-repeat: no-repeat;
	background-size: cover;
  -webkit-filter: grayscale(50%);
	filter: grayscale(50%);
}

.aligner {
  text-shadow: 0 1px 3px rgba(0,0,0,.5);
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

#register-user-form {
  width: 300px;
}

#submit-user-btn, #register-user-success-btn {
  display: block;
	margin-top: 10px;
	width: 300px;
	height: 40px;
	border-radius: 2px;
	background-color: #f8f8f8;
}

input[type="email"], input[type="password"] {
	width: 100%;
	height: 40px;
	line-height: 40px;
	border: 1px solid #dbdbdb;
	padding-left: 5px;
}

.error {
	padding-left: 5px;
	background-color: #fff;
	color: red;
	text-shadow: none;
	text-align: left;
	border: 1px solid #e6177a;
	border-top: none;
}

.error-outline {
	border: 1px solid #e6177a !important;
}
</style>
